module.exports = __webpack_public_path__ + "static/media/polpo.0b5af15e.svg";